import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'
import { authRoutes } from '@modules/auth'
import { landingViewRoutes } from '@modules/landingView'

export const publicRoutes: RouteRecordRaw[] = [
  ...authRoutes,
  {
    path: routes.ERROR,
    name: 'ERROR',
    component: () => import('@app/pages/ErrorPage.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NOT_FOUND',
    component: () => import('@app/pages/NotFoundPage.vue'),
  },
  ...landingViewRoutes,
]
